
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 510 508"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"fill-current",attrs:{"clip-rule":"evenodd","d":"M231 15.13c0-8.594-7.411-15.36-15.9-14.027C93.22 20.255 0 125.741 0 253c0 140.833 114.167 255 255 255s255-114.167 255-255c0-126.89-92.681-232.133-214.042-251.728C287.45-.102 280 6.674 280 15.292c0 7.442 5.619 13.64 12.956 14.882C399.701 48.225 481 141.118 481 253c0 124.816-101.184 226-226 226S29 377.816 29 253c0-112.209 81.776-205.318 188.981-222.983C225.347 28.804 231 22.594 231 15.13z"}})])
          )
        }
      }
    